import { components, constants, useServices} from 'cng-web-lib'
import HSCodeApiUrls from 'src/apiUrls/HSCODEApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router-dom'

const {
  form: { CngEditForm }
} = components

const {
  filter: { EQUAL }
} = constants

function EditPage({ showNotification }) {
  const { id } = useParams()
  const { fetchRecords } = useServices()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngEditForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          /*fetch={{
            url: HSCodeApiUrls.GET
          }}*/
          fetch={{
            onSendRequest: (onSuccess, onError, onComplete) => {
              fetchRecords.execute(
                HSCodeApiUrls.GET,
                {
                  filters: [{ field: 'id', operator: EQUAL, value: id }],
                  customData: { codeMType: 'HSCode' }
                },
                onSuccess,
                onError,
                onComplete
              )
            }
          }}
          update={{
            url: HSCodeApiUrls.PUT
          }}
          id={id}
        />
      </Grid>
    </Grid>
  )
}

export default EditPage
